import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import {
	Button,
	Modal,
	ProgressIndicator
} from "rhombus-react";

import { getLinkedCreatives } from "reducers/DTrees";

import CreativesTable from "widgets/table/CreativesTable";

import "./LinkedCreativesModal.css";

export default function LinkedCreativesModal(props){
	let {
			id:dtreeId,
			libraryId,
			name,
			commonModalProps,
			navigationActions: { popModal },
		} = props

		, title = name ? `Linked Creatives - ${name}` : "Linked Creatives";

	const [linkedCreatives, setlinkedCreatives] = useState([])
		, [isLoaded, setIsLoaded] = useState(false)
		, dispatch = useDispatch();


	useEffect(()=>{
		dispatch(getLinkedCreatives(libraryId, dtreeId)).then((creatives) => {
			setIsLoaded(true);
			if(creatives?.length){
				setlinkedCreatives(creatives);
			}
		});
	}, []);

	function Content(){
		return (
			<div className="linked-creatives-container height-limited">
				<ProgressIndicator isLoading={!isLoaded} />
				<div className="info">Creatives that are in use by this decision tree:</div>

				<CreativesTable creatives={linkedCreatives} shouldLinkPreview={false} />
			</div>
		);
	}

	function Footer(){
		return (
			<Button
				onClick={popModal}
				theme="default"
			>
				Back
			</Button>
		);
	}

	let modalProps = {
		...commonModalProps,
		className: `${commonModalProps.className} linked-creatives-modal`,
		title,
		renderContent: Content,
		renderFooter: Footer,
	};

	return (
		<Modal {...modalProps} />
	);
}

LinkedCreativesModal.displayName = "LinkedCreativesModal";
LinkedCreativesModal.propTypes = {
	dtree: PropTypes.object,
	commonModalProps: PropTypes.object,
	navigationActions: PropTypes.object,
};
